import styled from "styled-components";

export const AccountDetailsContainer = styled.div`
  margin-bottom: 24px;
`;

export const StrategyDetailsContainer = styled(AccountDetailsContainer)`
  padding: 20px 0px 0px;
  * {
    box-shadow: none;
  }

  .table-container {
    border: 1px solid #e9eaeb;
  }
`;

export const MetricItem = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e9eaeb;
  margin-bottom: 15px;
  box-shadow: 0px 1px 2px 0px rgba(10, 13, 18, 0.05);
  display: flex;
  flex-direction: column;
  gap: 12px;

  .metric-heading {
    color: #181d27;
    font-family: "Geist", sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 1.5em;
    margin: 0;
  }

  .metric-content {
    display: flex;
    align-items: flex-end;
    gap: 16px;

    .metric-left {
      display: flex;
      flex-direction: column;
      gap: 12px;
      flex: 1;

      .metric-value {
        color: #181d27;
        font-family: "Aeonik", sans-serif;
        font-weight: 400;
        font-size: 24px;
        line-height: 1.33em;
        margin: 0;
        font-variant-numeric: tabular-nums;

        .metric-value-decimal {
          font-size: 16px;
          line-height: 1;
          vertical-align: super;
          padding-left: 2px;
        }
      }

      .metric-change {
        display: flex;
        align-items: center;
        gap: 8px;

        .change-badge {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 2px;

          .arrow-icon {
            width: 16px;
            height: 16px;

            svg {
              width: 9.33px;
              height: 9.33px;
              stroke: #17b26a;
              stroke-width: 2px;
            }
          }

          .change-percentage {
            color: #079455;
            font-family: "Public Sans", sans-serif;
            font-weight: 500;
            font-size: 14px;
            line-height: 1.43em;
            margin: 0;
            font-variant-numeric: tabular-nums;
          }
        }

        .change-text {
          color: #535862;
          font-family: "Public Sans", sans-serif;
          font-weight: 500;
          font-size: 14px;
          line-height: 1.43em;
          margin: 0;
        }
      }
    }

    .metric-chart {
      width: 112px;
      height: 56px;
      position: relative;

      .chart-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 1px;
      }

      .chart-line {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        svg {
          width: 100%;
          height: 100%;

          path {
            stroke-width: 2px;
            fill: none;
          }
        }
      }

      .chart-marker {
        position: absolute;
        top: 7px;
        right: 46px;
        width: 19.25px;
        height: 19.25px;

        .marker-ring {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: 2px solid #17b26a;
          border-radius: 50%;
          opacity: 0.2;
        }

        .marker-dot {
          position: absolute;
          top: 4.38px;
          left: 4.38px;
          width: 10.5px;
          height: 10.5px;
          background: #ffffff;
          border: 2px solid #17b26a;
          border-radius: 50%;
        }
      }
    }
  }
`;

export const TotalReturnContainer = styled.div`
  padding: 20px 0px;
  background: #ffffff;
`;

export const ViewPortfolioHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  .portfolio-title {
    color: rgba(10, 13, 18, 0.9);
    font-family: "Geist", sans-serif;
    font-weight: 500;
    font-size: 18px;
    line-height: 1.5em;
    margin: 0;
  }

  .button-group {
    display: flex;
    align-items: center;
    height: 28px;
    border-radius: 8px;
    border: 1px solid #d5d7da;
    overflow: hidden; /* ensure children respect rounded corners */
    /* Shadows/shadow-xs-skeuomorphic */
    box-shadow: 0 0 0 1px rgba(10, 13, 18, 0.18) inset,
      0 -2px 0 0 rgba(10, 13, 18, 0.05) inset, 0 1px 2px rgba(10, 13, 18, 0.05);

    .button-option {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 6px;
      padding: 2px 12px;
      cursor: pointer;
      /* add separators only between items to avoid double borders at ends */
      border-right: none;
      background: #ffffff; /* Unactive */
      color: #717680;
      font-family: "Geist", sans-serif;
      font-weight: 500;
      font-size: 12px;
      line-height: 1.5em;
      transition: all 0.2s ease;

      &:not(:last-child) {
        border-right: 1px solid #d5d7da;
      }

      &.active {
        background: #fafafa; /* Active */
        color: #252b37;
      }

      &:hover:not(.active) {
        background: rgba(250, 250, 250, 0.5);
      }
    }
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  @media (max-width: 1200px) {
    .mobile-view-header {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      .mobile-view-inner-section {
        width: 100%;
        justify-content: space-between;
        flex-direction: row;
      }
    }
  }
`;

export const ChartTopContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
`;

export const EditButtonWrapper = styled.span`
  position: relative;
  display: inline-flex;

  .stale-dot {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 8px;
    height: 8px;
    background: #ff3f3f;
    border: 1.5px solid #ffffff;
    border-radius: 50%;
    pointer-events: none;
    box-shadow: 0 0 0 1px rgba(255, 63, 63, 0.25);

    &::after {
      content: "";
      position: absolute;
      inset: -3px;
      border-radius: 50%;
      background: #ff3f3f;
      opacity: 0.35;
      animation: stale-dot-pulse 1.8s ease-out infinite;
    }
  }

  @keyframes stale-dot-pulse {
    0% {
      transform: scale(0.6);
      opacity: 0.5;
    }
    70% {
      transform: scale(1.4);
      opacity: 0;
    }
    100% {
      transform: scale(1.4);
      opacity: 0;
    }
  }
`;
